/* eslint-disable default-param-last */
import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import RdimsReducer from './rdims';
import {
  CirbReducer, institutionDetailsReducer, CirbAdditoinDetailsReducer, CirbProcessingQueueReducer
} from './cirb';
import PacketReducer from './packets';
import IRBReducer from './irb';
import { CommonReducer, InstitutionReducer, EmailReducer } from './common';
import SiteRegistrationReducer from './siteRegistration';

export const EmptyReducer = (state = null) => state;

const rootReducer = (history) => combineReducers({
  router: connectRouter(history),
  empty: EmptyReducer,
  rdims: RdimsReducer,
  cirb: CirbReducer,
  cirbAddtionaDetails: CirbAdditoinDetailsReducer,
  cirbProcessingQueue: CirbProcessingQueueReducer,
  packet: PacketReducer,
  common: CommonReducer,
  irb: IRBReducer,
  institutionDetails: institutionDetailsReducer,
  institutions: InstitutionReducer,
  email: EmailReducer,
  siteRegistration: SiteRegistrationReducer
});

export default rootReducer;
